import * as React from 'react'

import { Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles({
    introduction:{
        display:'flex',
        placeSelf:'center',
        flexDirection:'column',
        width: '70%',
        textAlign:'center',
        marginBottom: 30
    },
    anchor:{
        color: 'darkblue',
        textDecoration: 'none'
    }
})

export const Intro = () => {

    const classes = useStyle()

    return(
        <div className={classes.introduction} >
        <Typography variant='h6' > Protection des données personnelles </Typography>
        <Typography variant='subtitle1' > INFORMATION </Typography>
        <Typography variant='body2' >
            Vous souhaitez obtenir des informations sur les traitements de données personnelles gérés par l'AGR ou exercer vos droits sur les données vous concernant enregistrées dans ces traitements, pour plus d’information.
            Veuillez-vous référer à la <Button href='https://lesrestaurantsagr.fr/politique-de-confidentialite' size='small' className={classes.anchor}>mention d’information</Button>
        </Typography>
        <Typography variant='subtitle1'> CONTACTER LE DÉLÉGUÉ A LA PROTECTION DES DONNÉES (DPO) </Typography>
        <Typography variant='body2'>
            Si vous avez des questions concernant vos données à caractère personnel, vous pouvez remplir le formulaire ci-dessous.
            Ce formulaire ne doit pas être utilisé si votre demande concerne une autre entité que l'AGR.
            Les champs marqués d'un astérisque (*) sont obligatoires
        </Typography>
        </div>
    )
}